<script setup lang="ts">
import { useI18n } from "vue-i18n";

import AudioButton from "@/components/AudioButton.vue";
import type { GyldendalPronunciation } from "@/types/article-formats/gyldendal";

defineProps<{
  items: GyldendalPronunciation[];
}>();

const { t } = useI18n();
</script>

<template>
  <template v-for="(item, index) in items">
    <AudioButton
      v-if="item.soundFile"
      :key="`${index}-audio-button`"
      :audio-url="item.soundFile"
      :aria-label="t('article.pronunciation.label')"
      variant="negative"
    >
    </AudioButton>
    <span v-if="item.pronunciation" :key="`${index}-pronunciation`" class="mx-1"
      >[{{ item.pronunciation }}]</span
    >
  </template>
</template>
